// extracted by mini-css-extract-plugin
export default {"inbox":"ChatFilesContainer_inbox__t-zed"};